import { postRequest } from '../../../shared/utils';

export async function getPoKubuMapping(screenGridId: number) {
  const body = {
    columns: ['id', 'po_kubu'],
    orderCol: 'id',
    order: 'asc',
    screenGridId,
    schema: 'npi',
    table: 'tblopt_po_kubu',
  };
  const { data, errors } = await postRequest('/api/records', body);

  if (errors) {
    return [];
  }

  return data.npi_tblopt_po_kubu;
}
